import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class IndustryClassificationsCriteria extends FilterCriteria {
  constructor() {
    super();
    this.isPrimary = null;
  }
  public override title = 'Industry Classification';
  public override type: FilterTypes = FilterTypes.IndustryClassifications;
  industryTypeId: number = null;
  industryTypeText = '';
  isPrimary?: boolean = undefined;
  industryCodeSelectionLabel: TreeNode[] = [];
  industryCodeSelectionId: string[] = [];
  isPassIfNa?: boolean = null;

  public override validate(): boolean {
    return this.industryCodeSelectionId != null && this.industryCodeSelectionId.length > 0 && this.isPrimary !== undefined;
  }

  public override toString(): string {
    const code = this.isPrimary == null ? '(Primary and Secondary Codes)' : this.isPrimary ? '(Primary Codes)' : '(Secondary Codes)';
    const s: string = this.industryCodeSelectionLabel ? this.industryCodeSelectionLabel.map((a) => a.label).join(', ') : '<null>';
    return 'Industry Classification: ' + this.industryTypeText + ' ' + code + ' ' + s;
  }
}
